/* global wrapup */
import React, { Component } from 'react';

window.wrapup = window.wrapup || {cmd: []};
export default class extends Component {
  constructor(props) {
    super(props);
    this.code = props.code;
    this.id = `${this.code}_${Math.ceil(Math.random()*9999)}`;
  }
  componentDidMount() {
    wrapup.cmd.push(() => { wrapup.defineSlot(this.id, this.code) });
  }
  componentWillUnmount() {
    wrapup.cmd.push(() => { wrapup.destroySlot(this.id) });
  }
  render() {
    return (
      <div id={`ctr_${this.id}`}>
        <div id={`spr_${this.id}`}></div>
        <div id={this.id}></div>
      </div>
    );
  }
}
